export default function translate(i18n, propriete) {
  if (propriete === 'montantHt') {
    return i18n.t('addEditOrdreTravailTech.caracterique.infoGenerale.montantHT');
  }
  if (propriete === 'dateSouhaitee') {
    return i18n.t('addEditOrdreTravailTech.caracterique.infoGenerale.dateSouhaite');
  }
  if (propriete === 'typeOtId') {
    return i18n.t('addEditOrdreTravailTech.caracterique.infoGenerale.typeIntervention');
  }
  if (propriete === 'otPatrimoine.DispositifTechnique.ValeurAcquisition') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.valeurAcquisition');
  }
  if (propriete === 'otPatrimoine.DispositifTechnique.Longueur') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.longueur');
  }
  if (propriete === 'otPatrimoine.DispositifTechnique.DistanceEnMCablesEdf') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.distanceEnMCablesEdf');
  }
  if (propriete === 'otPatrimoine.DispositifTechnique.HauteurSousPanneau') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.hauteurSousPanneau');
  }
  if (propriete === 'otPatrimoine.DispositifTechnique.LargeurToit') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.dispositif.champs.largeurToit');
  }
  if (propriete === 'otPatrimoine.EmplacementTechnique.NumUG') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.emplacement.champs.numUg');
  }
  if (propriete === 'otPatrimoine.EmplacementTechnique.Quartier') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.emplacement.champs.quartier');
  }
  if (propriete === 'otPatrimoine.EmplacementTechnique.GroupeDhabitation') {
    return i18n.t('addEditOrdreTravailTech.patrimoine.emplacement.champs.groupeDhabitation');
  }
  if (propriete.indexOf('taches') === 0) {
    const msgs = propriete.split('.');
    if (msgs[1] === 'Libelle') return i18n.t('addEditOrdreTravailTech.messages.error.libelleTache');
    if (msgs[1] === 'Description') return i18n.t('addEditOrdreTravailTech.messages.error.libelleDescription');
  }
  if (propriete === 'tiersId') {
    return i18n.t('addEditOrdreTravailTech.otStock.tiersId');
  }
  if (propriete === 'quantite') {
    return i18n.t('addEditOrdreTravailTech.otStock.quantite');
  }
  if (propriete === 'nomFichierRip') {
    return i18n.t('addEditOrdreTravailTech.otStock.nomFichierRip');
  }
  if (propriete === 'graphisteEnChargeId') {
    return i18n.t('addEditOrdreTravailTech.otStock.graphisteEnChargeId');
  }
  if (propriete === 'userId') {
    return i18n.t('listeOtImpression.popUpSelectionTechnicien.selectTechnicien');
  }
  if (propriete === 'etatSouhaite') {
    return i18n.t('listeOtImpression.popUpSelectionTechnicien.etatSouhaite');
  }
  return propriete;
}
